import { FC } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { partnersQueries } from '@/api/partners.service';

import './Logo.scss';

import { getPublicFileLogo } from '@/api';
import { PartnerDto } from '@/generated-types';

const defaultCompanyUrl = 'https://loanbud.com/';

interface ILogoProps {
	className?: string;
}

const Logo: FC<ILogoProps> = ({ className = '' }) => {
	const queryClient = useQueryClient();

	const data = queryClient.getQueryData<Required<PartnerDto>>(partnersQueries.partner.me.queryKey);

	const getCompanyUrl = (url: string | undefined): string => {
		if (!url) {
			return defaultCompanyUrl;
		}
		if (url.startsWith('http://') || url.startsWith('https://')) {
			return url;
		}
		return `https://${url}`;
	};

	return (
		<a
			className={`company-link ${className}`}
			data-testid="company-link"
			href={getCompanyUrl(data?.url)}
			rel="noopener noreferrer"
			target={'_blank'}
		>
			<img
				alt={'company logo'}
				className={'company-logo'}
				data-testid="company-logo"
				src={getPublicFileLogo(data?.logo?.id)}
			/>
		</a>
	);
};

export default Logo;
